import config from '../../../config'
import Cookies from 'js-cookie'
import { NOTIFICATION_STATUSES } from '../constants'

export const fetchFirebaseCloudMessagingList = async ({ status = NOTIFICATION_STATUSES.UNKNOWN, pageParam = 1 }) => {
  const params = new URLSearchParams()
  params.append('eventType', 'FCM')
  params.append('status', status)
  params.append('page', pageParam)
  params.append('limit', 10)

  const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/eventscheduler?${params.toString()}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      throw err
    })

  return response
}

export const createFirebaseCloudMessaging = async (formData) => {
  const params = new URLSearchParams()
  const payloadString = JSON.stringify(formData.payload)

  params.append('eventType', 'FCM')
  params.append('payload', payloadString)
  params.append('schedule', formData.schedule)

  const url = `${config.apiAdminGateway}/api/v1/admin/eventscheduler/create?${params.toString()}`
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
    body: formData,
  })
    .then((res) => res.json())
    .catch((err) => {
      console.error('error : ', err)
    })

  return response
}

export const updateFirebaseCloudMessaging = async (formData) => {
  const params = new URLSearchParams()
  params.append('id', formData.id)
  params.append('remark', formData.remark)

  const response = await fetch(`${config.apiAdminGateway}/api/v1/admin/eventscheduler?${params.toString()}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('accessToken')}`,
    },
  })
    .then((res) => res.json())
    .catch((err) => {
      console.log('error : ', err)
    })

  return response
}
